import { useEffect } from "react";
import Sidebar from "../sideBar/SideBar";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { UserData } from "../../redux/actions/userAuthActions";
import UserToggleHonoraires from "../../components/commons/UserToggleHonoraires";
import UserProfile from "../../components/commons/UserProfile";
import Container from "../../components/Container/Container";
import Modal from "../../components/commons/Modal";
import "./stylesLayout.css";

const MainLayout = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem("token");
  const isLoginPage = location.pathname === "/login";
  const isPwdResetPage = location.pathname === "/pwd-reset";
  const dispatch = useDispatch();

  const { isAuthenticated, role, userLoading } = useSelector(
    (state) => state.userAuthReducer
  );

  useEffect(() => {
    dispatch(UserData());
  }, [token, role]);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns:
          isLoginPage || isPwdResetPage ? "1fr" : "250px 1fr",
        gridTemplateRows: "1fr auto",
        minHeight: "100vh",
      }}
    >
      {/* Sidebar */}
      {!isLoginPage && !isPwdResetPage && (
        <aside style={{ gridColumn: "1 / 2", gridRow: "1 / 2" }}>
          <Sidebar />
        </aside>
      )}

      {/* Main Content */}
      <main
        role="main"
        style={{
          gridColumn: isLoginPage || isPwdResetPage ? "1 / 2" : "2 / 3",
          gridRow: "1 / 2",
          padding: isLoginPage || isPwdResetPage ? "0px" : "40px",
        }}
        className=""
      >
        <div className="mainLayout">
          <div>
            {!isLoginPage && !isPwdResetPage && (
              <div className="header">
                <Container className="toggleContainer ">
                  <UserToggleHonoraires />
                  <UserProfile />
                </Container>
              </div>
            )}
            <Container className="mainContent p-0">{children}</Container>
          </div>
        </div>
      </main>

      {/* Modal */}
      <Modal />
    </div>
  );
};

export default MainLayout;
